import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function ImageBreak() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section
      ref={ref}
      data-testid="office-image-band"
      className="relative h-[420px] lg:h-[540px] overflow-hidden"
    >
      <motion.img
        src="/assets/office.jpg"
        alt="Espace d'accompagnement — un bureau chaleureux et professionnel"
        style={{ y }}
        className="absolute inset-0 w-full h-[120%] object-cover"
      />
      <div className="absolute inset-0 bg-[#0A1120]/55" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1120] via-transparent to-[#0A1120]" />
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <p className="font-mono-accent text-[11px] uppercase tracking-[0.4em] text-[#D4AF37]">
          Le cadre
        </p>
        <p className="font-serif-display mt-4 text-3xl lg:text-5xl italic text-white max-w-2xl leading-tight">
          Un espace pensé pour la confidence.
        </p>
      </div>
    </section>
  );
}
